/**
 * HTML Sanitization Utility
 * Uses DOMPurify to sanitize HTML content and prevent XSS attacks
 */
import DOMPurify from 'dompurify'

/**
 * Sanitize HTML content for safe rendering
 * @param {string} dirty - Unsanitized HTML string
 * @returns {string} - Sanitized HTML string safe for dangerouslySetInnerHTML
 */
export function sanitizeHTML(dirty) {
  if (!dirty) return ''
  
  // Configure DOMPurify with strict settings
  const config = {
    ALLOWED_TAGS: [
      'p', 'br', 'strong', 'em', 'u', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'ul', 'ol', 'li', 'blockquote', 'code', 'pre', 'a', 'img',
      'div', 'span', 'hr', 'table', 'thead', 'tbody', 'tr', 'td', 'th'
    ],
    ALLOWED_ATTR: [
      'href', 'title', 'alt', 'src', 'width', 'height', 'class', 'id',
      'target', 'rel', 'colspan', 'rowspan'
    ],
    ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
    KEEP_CONTENT: true,
    RETURN_DOM: false,
    RETURN_DOM_FRAGMENT: false,
    RETURN_TRUSTED_TYPE: false
  }
  
  return DOMPurify.sanitize(dirty, config)
}

/**
 * Sanitize text content (strips all HTML)
 * @param {string} dirty - HTML string
 * @returns {string} - Plain text
 */
export function sanitizeText(dirty) {
  if (!dirty) return ''
  return DOMPurify.sanitize(dirty, { ALLOWED_TAGS: [] })
}

